import articlePage from "@faire/web-api/routes/support/articles/articleId";
import { Button } from "@faire/web/slate/Button";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { MessageRetailerOrBrandButton, additionalDataRequiredForContactingRetailerOrBrandCTA } from "../../shared/instantAnswerUtils";
import { ExtendReturnDateCTA } from "./ctas";
import { NEED_MORE_INFO_ANSWER } from "./shared";
export var ExtendReturnIA = function ExtendReturnIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getPrimaryCTA;
        return (_getPrimaryCTA = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA === void 0 ? void 0 : _getPrimaryCTA.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getPrimaryCTA2, _getPrimaryCTA2$getLi;
        return (_getPrimaryCTA2 = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA2 === void 0 ? void 0 : (_getPrimaryCTA2$getLi = _getPrimaryCTA2.getLink) === null || _getPrimaryCTA2$getLi === void 0 ? void 0 : _getPrimaryCTA2$getLi.call(_getPrimaryCTA2, context.brandOrder);
      }
    },
    secondaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _MessageRetailerOrBra;
        return (_MessageRetailerOrBra = MessageRetailerOrBrandButton(context, strictLocalize)) === null || _MessageRetailerOrBra === void 0 ? void 0 : _MessageRetailerOrBra.label;
      },
      onClickFunctionBuilder: function onClickFunctionBuilder(context) {
        var _MessageRetailerOrBra2;
        return (_MessageRetailerOrBra2 = MessageRetailerOrBrandButton(context, strictLocalize)) === null || _MessageRetailerOrBra2 === void 0 ? void 0 : _MessageRetailerOrBra2.onClick;
      }
    },
    additionalRequiredData: additionalDataRequiredForContactingRetailerOrBrandCTA()
  };
};
var getAnswer = function getAnswer(context, strictLocalize) {
  var brandOrder = context.brandOrder,
    shippingContext = context.shippingContext;
  if (!brandOrder || !shippingContext) {
    return NEED_MORE_INFO_ANSWER(strictLocalize);
  }
  return shippingContext.is_return_extension_eligible ? RETURN_EXTENSION_ELIGIBLE(strictLocalize) : RETURN_EXTENSION_INELIGIBLE(strictLocalize);
};
var getPrimaryCTA = function getPrimaryCTA(context, strictLocalize) {
  var brandOrder = context.brandOrder,
    shippingContext = context.shippingContext;
  if (!brandOrder || !shippingContext || !shippingContext.is_return_extension_eligible) {
    return undefined;
  }
  return ExtendReturnDateCTA(strictLocalize);
};
var RETURN_EXTENSION_ELIGIBLE = function RETURN_EXTENSION_ELIGIBLE(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return EXTEND_RETURN_WINDOW(strictLocalize);
    },
    getDescription: function getDescription() {
      return [EXTEND_RETURN_WINDOW_FOR_NET_ORDER_TERMS(strictLocalize), OPTION_NOT_AVAILABLE_AFTER_RETURN_WINDOW(strictLocalize)];
    }
  };
};
var RETURN_EXTENSION_INELIGIBLE = function RETURN_EXTENSION_INELIGIBLE(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return NOT_ELIGIBLE_FOR_RETURN_EXTENSION(strictLocalize);
    },
    getDescription: function getDescription() {
      return /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
        id: "yhkdTD",
        defaultMessage: [{
          "type": 0,
          "value": "La prolongation du délai de retour est uniquement disponible pour les commandes effectuées avec le paiement à 60 jours. Pour demander une prolongation, la période de retour doit être respectée. Toute demande de prolongation ne peut être effectuée qu'une fois la commande livrée. Retrouvez plus d'informations sur notre "
        }, {
          "children": [{
            "type": 0,
            "value": "Politique relative aux prolongations du délai de retour"
          }],
          "type": 8,
          "value": "ReturnExtensionPolicyLinkFormatting"
        }, {
          "type": 0,
          "value": " ou contactez la marque pour étudier d'autres solutions."
        }],
        values: {
          ReturnExtensionPolicyLinkFormatting: LinkFormatting(articlePage("360022876131"))
        }
      }));
    }
  };
};
var EXTEND_RETURN_WINDOW = function EXTEND_RETURN_WINDOW(strictLocalize) {
  return strictLocalize({
    id: "HQRdq5",
    defaultMessage: [{
      "type": 0,
      "value": "Prolongez votre délai de retour"
    }]
  });
};
var EXTEND_RETURN_WINDOW_FOR_NET_ORDER_TERMS = function EXTEND_RETURN_WINDOW_FOR_NET_ORDER_TERMS(strictLocalize) {
  return strictLocalize({
    id: "Kbf/Xs",
    defaultMessage: [{
      "type": 0,
      "value": "Vous avez la possibilité de prolonger votre délai de retour pour les commandes passées en utilisant vos conditions de paiement. Moyennant des frais supplémentaires de 3 % sur les commandes pouvant être renvoyées, vous aurez la possibilité de prolonger votre période de retour de 30 jours supplémentaires."
    }]
  });
};
var OPTION_NOT_AVAILABLE_AFTER_RETURN_WINDOW = function OPTION_NOT_AVAILABLE_AFTER_RETURN_WINDOW(strictLocalize) {
  return strictLocalize({
    id: "4Zy3GU",
    defaultMessage: [{
      "type": 0,
      "value": "Veuillez noter que l'option de prolongation ne sera plus disponible après la date limite de retour. Une fois votre demande de retour effectuée, vous devez renvoyer le produit avant la date d'échéance indiquée sur votre bordereau de retour."
    }]
  });
};
var NOT_ELIGIBLE_FOR_RETURN_EXTENSION = function NOT_ELIGIBLE_FOR_RETURN_EXTENSION(strictLocalize) {
  return strictLocalize({
    id: "YawbU6",
    defaultMessage: [{
      "type": 0,
      "value": "Cette commande ne peut pas faire l'objet d'une prolongation du délai de retour"
    }]
  });
};
var LinkFormatting = function LinkFormatting(linkTo) {
  return function (chunks) {
    return /*#__PURE__*/React.createElement(Button, {
      linkTo: linkTo,
      variant: "tertiary"
    }, chunks);
  };
};